<template lang="html">

  <section class="hemeroteca-events">
    <hero-global img="/img/hero/actualidad.svg" title="Actualidad" subtitle="Actualidad" />
    <section id="multimedia" class="container">
      <div class="column-center">
        <h2 class="title-grand title__double-center" data-text="Histórico Agenda">Agenda</h2>
      </div>
      <div class="d-flex jcfe aie m-bottom-20-px">
        <select-years @changed="setYear" :dataYear="yearSelected"></select-years>
      </div>
      <template v-if="loading">
        <div class="result-box container">
          <p class="subtitle">Cargando...</p>
        </div>
      </template>
      <template v-else>
      <section class="grid-3" v-if="store.getEventsLatest(this.yearSelected, this.page)">
        <template v-for="(event, index) in Object.values(store.getEventsLatest(this.yearSelected, this.page))" :key="index">
          <eventViewSimple :dataContent="event" typeContent="event"></eventViewSimple>
        </template>
      </section>
      <template v-else>
        <div class="result-box container">
          <p class="subtitle">Lo sentimos no hay resultados</p>
        </div>
      </template>
      </template>
      <paginator class="m-bottom-5-rem" v-if="store.getEventsLatest(this.yearSelected, this.page)" :pageActual="page" :totalItems="EventsMaxItems" @clicked="changePages" @changed="changePages" />
    </section>
    <other-links-interest class="links-interest-box container" />
  </section>

</template>

<script lang="js">
  import HeroGlobal from "@/components/Global/HeroGlobal";
  import Paginator from "@/components/Global/PaginationGlobal";
  import SelectYears from "@/components/Global/SelectYears";
  import OtherLinksInterest from "@/components/Layout/OtherLinksInterest";
  import eventViewSimple from "@/components/Card/EventViewSimple";
  import { contentStore } from '@/stores/contents'
  const store = contentStore();
  export default {
    name: 'hemeroteca',
    props: ['idDay'],
    components: {
      OtherLinksInterest,
      HeroGlobal,
      eventViewSimple,
      Paginator,
      SelectYears
    },
    setup() {
      return {
        store,

      }
    },
    mounted() {
      this.store.loadEventsLatests(
        {
          page: this.page,
          maxDate: new Date(),
        }
      )
    },
    data() {
      return {
        fullPage: false
      }

    },
    methods: {
      changePages(item, page) {
        this.store.setPagesEvents(item)
        this.store.loadEventsLatests(
          {
            maxYear: this.yearSelected,
            page: this.page,
          }
        )

        setTimeout(function () {
          scroll({
            behavior: "smooth",
            top: 0,
          });
        }, 200);
      },
      setYear(year) {
        this.year = year
         this.page = 1
        this.store.eventsLatest.lastFilters.date = year
        this.store.setPagesEvents(1)
        this.store.loadEventsLatests(
          {
            maxYear: this.year,
            page: 1,
          }
        )
      }


    },
    computed: {
      EventsMaxItems() {
        return this.store.getPagesEventsLatests(this.yearSelected);
      },
      page() {
        return this.store.eventsLatest.viewPage
      },
      loading() {
        return this.store.loading
      },
       yearSelected() {
        let year = new Date().getFullYear()
        if (this.store.eventsLatest.lastFilters.date) {
          year = this.store.eventsLatest.lastFilters.date
        }
        return year
      }
    },
    watch: {
      "loading"() {
        if (this.loading) {
          let loader = this.$loading.show({
            container: this.$refs.loadingContainer,
            zIndex: 99,
          });
          setTimeout(() => {
            loader.hide()
          }, 1000)
        }
      }
    }
  }


</script>

<style scoped lang="scss">
  @import "@/styles/general.scss";

  .hemeroteca-events {
    .title-grand {
      margin-bottom: 25px;
      color: #8baddc5e;
    }

    .result-box {
      min-height: 38vh;
      display: flex;
      justify-content: center;
      align-items: flex-start;

      .subtitle {
        font-size: 30px;
        border-bottom: 1px solid;
      }
    }
  }
</style>